import React, { useState, useMemo, useEffect } from 'react';
import $ from 'jquery';
import Clock from '../../clock/clock';
import ScoreToolBlock from './toolblock/toolblock';
import TextMessage from './text-message/text-message.js';
import ScoringItem from '../scoring-item/scoring-item.js';
import DBHandler from '../../../javascript/index-db/db-handler.js';
import ServingIndicator from './serving-indicator/serving-indicator.js';
// import { castUpdateInfoPopUp } from '../../../javascript/cast/cast-control.js';
import { ConfirmModel, Sleep, Timestamp, CloseAllSwal } from '../../../javascript/utils/utils.js';
import { endGame, speech, build_sport_function, speech_translate, endMatchPrompt, get_pre_score, trigger_quick_sync } from '../../../javascript/sport/sport-function.js';
import ConnectionIndicator from '../../connection-indicator/connection-indicator.js';
import BackgroundSoundIndicator from '../../background-sound-indicator/background-sound-indicator.js';
import { SPORT_BASE, NAV_CONTROL } from '../../../javascript/services/globalVars.js';
import useIsLandscape from '../../../javascript/utils/use-is-landscape.js';
import style from './scoring-block-style.module.scss';
function ScoringBlock(Props) {
   const isLandscape = useIsLandscape();
   const [gameTimer, setGameTimer] = useState(() => { });
   const [gameTimer_2, setGameTimer_2] = useState(() => { });
   const [hideGameTimer, setHideGameTimer] = useState(() => false);
   const [hideGameTimer_2, setHideGameTimer_2] = useState(() => true);
   const [debounceTime, setDebounceTime] = useState(() => Timestamp());
   const [scoreLeft, setScoreLeft] = useState(() => { });
   const [scoreRight, setScoreRight] = useState(() => { });
   const [colorTable, setColorTable] = useState(() => { });
   const [servingState, setServingState] = useState(() => { });
   const [scoreUpdate, setScoreUpdate] = useState(() => 0);
   const [btnList, setBtnList] = useState(() => []);
   const [sideSwap, setSideSwap] = useState(() => false);

   let styleHeight = '';
   if (Props.cssHeight === '70') {
      styleHeight = style.hight70;
   }

   const confirm_game_won = async () => {
      // console.log('>>> confirm_game_won <<<');

      const scoring = SPORT_BASE.sport_object.scoring;
      // console.log('>>> confirm_game_won <<<', SPORT_BASE.sport_object.game_state);
      // console.log('gameTimer: ', gameTimer);


      if (SPORT_BASE.sport_object.game_state === 'running' && gameTimer !== false) {
         // console.warn('Hit');

         const active_match_id = SPORT_BASE.sport_object.scoring.state.match.id;
         const loaded_match = await SPORT_BASE.loadMatch(active_match_id);

         // console.log('loaded_match: ', loaded_match);
         // console.log('loaded_match.match_state: ', loaded_match.match_state);
         // console.log('scoring.scoring.match_won: ', scoring.scoring.match_won);


         // console.log('[CONFIRM_GAME_WON] - match_state: ', loaded_match.match_state);


         if (loaded_match.match_state === 'match_won' && !scoring.scoring.match_won) {
            // console.error('\n\n match_state is not running, Stopping confirm_game_won popup \n\n ');
            return;
         }

         const wordType = scoring.scoring.match_won ? 'Match' : speech_translate('game');
         const game_state = scoring.scoring.match_won ? 'match_complete' : 'game_complete';

         // console.error('scoring.scoring.won: ', scoring.scoring);
         // console.error('scoring.scoring.won: ', scoring.scoring.won);




         if (scoring.scoring.won && $('.swal2-container').length === 0) {
            if (typeof SPORT_BASE?.sport_object?.scoring?.state?.match?.cast_data?.info_pop_up !== 'undefined') {
               await Sleep(100);
               SPORT_BASE.sport_object.scoring.state.match.cast_data.info_pop_up.update({
                  title: `${wordType} completed?`,
                  message: `Are you sure?`,
                  icon: '',
                  timer: false,
                  clear: false,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'Go Back!',
                  showCancelButton: true,
                  showConfirmButton: true,
               });
               await SPORT_BASE.saveActiveMatch();
               await trigger_quick_sync('confirm_game_won - open prompt');
            }

            ConfirmModel({
               title: `${wordType} completed?`,
               text: `Are you sure?`,
               confirmButtonText: 'Yes',
               cancelButtonText: 'Go Back!',
               allowOutsideClick: false,
               confirm_button_delay: 3,
               preConfirm: async (result) => {
                  return new Promise(async (resolve) => {
                     if (typeof SPORT_BASE?.sport_object?.scoring?.state?.match?.cast_data?.info_pop_up !== 'undefined') {
                        SPORT_BASE.sport_object.scoring.state.match.cast_data.info_pop_up.update({ clear: true });
                        await SPORT_BASE.saveActiveMatch();
                        await trigger_quick_sync('confirm_game_won - clear prompt');
                     }

                     if (result) {
                        stopClocks();
                        speech(wordType);
                        SPORT_BASE.sport_object.scoring.scoring.update_last_call_text(wordType);
                        let is_total_of_match_win_tie = false;
                        if (typeof SPORT_BASE.sport_object.scoring.scoring.is_total_of_match_win_tie === 'function') {
                           is_total_of_match_win_tie = SPORT_BASE.sport_object.scoring.scoring.is_total_of_match_win_tie();
                        }
                        if (is_total_of_match_win_tie) {
                           await endMatchPrompt(false);
                        } else {
                           const dbHandler = DBHandler();
                           await dbHandler.update_app_state({ update: Timestamp(), game_state: game_state, });
                           await endGame();

                        }
                     }
                     await Sleep(250);
                     resolve(true);
                  });
               }

            }).then(async (result) => {
               // console.error('TODO: castUpdateInfoPopUp');
               // castUpdateInfoPopUp({ clear: true });

               if (!result.isConfirmed) {
                  SPORT_BASE.sport_object.scoring.scoring.undo();
                  if (typeof Props.callback === 'function') {
                     updateScore();
                     Props.callback();
                  }
               }
            }).finally(async () => {
               await Sleep(100);
               if (typeof SPORT_BASE?.sport_object?.scoring?.state?.match?.cast_data?.info_pop_up !== 'undefined') {
                  SPORT_BASE.sport_object.scoring.state.match.cast_data.info_pop_up.update({ clear: true });
                  await SPORT_BASE.saveActiveMatch();
                  await trigger_quick_sync('confirm_game_won - clear prompt - finally');
               }
            });
         }
      }
   }


   const trigger_score = async (args = {}) => {
      try {
         const timePassed = Timestamp() - debounceTime;
         if (timePassed < 350) {
            return false;
         }
         const scoring = SPORT_BASE.sport_object.scoring;
         if (!scoring.scoring.won) {
            const side = args.pos === 'left' ? 1 : 2;
            const score_fun = build_sport_function({ type: 'score', value: side });
            await score_fun();
         } else {
            console.log('WON?')
         }
         if (typeof Props.callback === 'function') {
            // console.error('>>> trigger_score - Calling callback ');
            // WARNING DO NOT WAIT ON THE CALLBACK HERE
            Props.callback();
         }
         refresh('trigger_score - ok');
         setDebounceTime(Timestamp());
      } catch (error) {
         console.error('ERROR - Score-Block - trigger_score - root: ', error);
         refresh('trigger_score - error');
         if (typeof Props.callback === 'function') { Props.callback(); }
         setDebounceTime(Timestamp());
      }
   }

   const updateScore = () => {
      try {
         const scoring = SPORT_BASE.sport_object.scoring;
         const color_table = SPORT_BASE.sport_object.scoring.state.match.players.color_table;
         const { left_pre, right_pre, mainScoreVisible } = get_pre_score();
         setScoreLeft({ score: scoring.scoring.team_1_score.value, pre: left_pre, pre_color: color_table[0], mainScoreVisible });
         setScoreRight({ score: scoring.scoring.team_2_score.value, pre: right_pre, pre_color: color_table[1], mainScoreVisible });
      } catch (error) {
         console.error('ERROR - Score-Block - updateScore - root: ', error);
      }
   }

   const stopClocks = () => {
      setGameTimer(false);
      setGameTimer_2(false);
   }

   const updateState = async (args) => {
      setSideSwap(args.scoring.state.match.active_game.side_swap);
      if (typeof args.scoring.state !== 'undefined') {
         const game_clock = 'game_clock';
         const continuous_clock = 'continuous_clock';

         if (typeof SPORT_BASE?.sport_object?.scoring?.state?.match?.cast_data?.info_pop_up !== 'undefined') {
            SPORT_BASE.sport_object.scoring.state.match.cast_data.info_pop_up.update({ clear: true });
         }


         if (SPORT_BASE.check_continuous_clock()) {
            const game_timber_2 = SPORT_BASE.getClock(continuous_clock);
            setGameTimer_2(game_timber_2);
            setHideGameTimer(true);
            setHideGameTimer_2(false);
         } else {
            setGameTimer_2(false);
            setHideGameTimer(false);
            setHideGameTimer_2(true);
         }

         const clockIndex = SPORT_BASE.sport_object.clocks.findIndex(clock => clock.id === game_clock);
         if (clockIndex !== -1) {
            const game_timer = SPORT_BASE.sport_object.clocks[clockIndex];
            setGameTimer(game_timer);
         }

         setServingState(args.scoring.state.serving); // <--- Seting Servering State From Scoring Object

         setColorTable(args.scoring.state.match.players.color_table);
         const tools = await args.get_tool_block('scoring');
         setBtnList(tools);
         updateScore();


         await Sleep(500);
         confirm_game_won();
      } else {
         stopClocks();
      }
   }

   const refresh = (_type) => {
      // console.log('Refresh');
      setScoreUpdate(v => v + 1);
   }

   useEffect(() => { updateState(SPORT_BASE.sport_object); }, [scoreUpdate])

   useEffect(() => {
      NAV_CONTROL.appendCallback('scoreBlock', () => {
         refresh('useEffect');
         if (NAV_CONTROL.state.kill_clocks === true) {
            stopClocks();
            NAV_CONTROL.state.kill_clocks = false;
         }
      });

      return () => {
         // >>> Runs on unLoad (Unload runs first if component is already mounted)
      };
   }, []);

   return (
      <div className={`${isLandscape ? `${styleHeight} ${style.scoreWrap}` : `${styleHeight} ${style.scoreWrapPortrait}`}`}>
         <div className={style.scoreHead}>
            <Clock settings={gameTimer} hidden={hideGameTimer} />
            <Clock settings={gameTimer_2} hidden={hideGameTimer_2} />
            <ConnectionIndicator />
            <BackgroundSoundIndicator />
         </div>

         {isLandscape ? (
            <>
               <div className={style.scoreBody}>
                  {!sideSwap ? <ScoringItem callback={trigger_score} settings={scoreLeft} pos="left" /> : <ScoringItem callback={trigger_score} settings={scoreRight} pos="right" />}
                  <div className={style.scoreToolBar}>
                     <ScoreToolBlock btnList={btnList} />
                  </div>
                  {!sideSwap ? <ScoringItem callback={trigger_score} settings={scoreRight} pos="right" /> : <ScoringItem callback={trigger_score} settings={scoreLeft} pos="left" />}
               </div>
               <div className={style.scoreFoot}>
                  {!sideSwap ? <ServingIndicator pos={1} servingState={servingState} update={scoreUpdate} colorTable={colorTable} /> : <ServingIndicator pos={2} servingState={servingState} update={scoreUpdate} colorTable={colorTable} />}
                  <TextMessage />
                  {!sideSwap ? <ServingIndicator pos={2} servingState={servingState} update={scoreUpdate} colorTable={colorTable} /> : <ServingIndicator pos={1} servingState={servingState} update={scoreUpdate} colorTable={colorTable} />}
               </div>
            </>
         ) : (
            <>
               <div className={style.scoreBodyPortrait}>
                  <>
                     {!sideSwap ? <ScoringItem callback={trigger_score} settings={scoreLeft} pos="left" /> : <ScoringItem callback={trigger_score} settings={scoreRight} pos="right" />}
                     {!sideSwap ? <ServingIndicator pos={1} servingState={servingState} update={scoreUpdate} colorTable={colorTable} /> : <ServingIndicator pos={2} servingState={servingState} update={scoreUpdate} colorTable={colorTable} />}
                  </>
                  {Props.children}
                  <>
                     {!sideSwap ? <ScoringItem callback={trigger_score} settings={scoreRight} pos="right" /> : <ScoringItem callback={trigger_score} settings={scoreLeft} pos="left" />}
                     {!sideSwap ? <ServingIndicator pos={2} servingState={servingState} update={scoreUpdate} colorTable={colorTable} /> : <ServingIndicator pos={1} servingState={servingState} update={scoreUpdate} colorTable={colorTable} />}
                  </>
               </div>
               <div className={style.scoreToolBarPortrait}>
                  <ScoreToolBlock btnList={btnList} />
               </div>
               <TextMessage />
            </>
         )}

      </div>
   );
}

export default ScoringBlock;